import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

const OPTS = {
  weekday: 'short', day: '2-digit', month: 'short', year: 'numeric',
  hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'Asia/Kolkata',
};

export const fmtStamp = (value, withSeconds = false) => {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-IN', withSeconds ? { ...OPTS, second: '2-digit' } : OPTS);
};

export default function LiveClock({ className = '', testid = 'live-clock' }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 tabular-nums ${className}`}>
      <Clock className="w-3.5 h-3.5 shrink-0"/>
      <time dateTime={now.toISOString()}>{fmtStamp(now, true)}</time>
    </span>
  );
}
